export default __webpack_public_path__ + "static/media/forest.7664bf0e.jpg";